import { ThemeProvider } from '@mui/material';
import { default as theme } from './MeshTheme';

export const MeshThemeProvider = ({ children }) => {
  return <ThemeProvider theme={theme}>{children}</ThemeProvider>
}

